import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { businessHours } from '../../configuration/configuration';

@Component({
    selector: 'rosie-schedule-hours',
    templateUrl: './schedule-hours.component.html',
    styleUrls: ['./schedule-hours.component.scss'],
    standalone: false
})
export class ScheduleHoursComponent implements OnInit, OnChanges {
    @Input() hoursFormArray: FormArray;
    @Input() showDayToggles: boolean = false;
    @Input() dataHook: string = 'BUSINESS.HOURS';
    @Input() startTimePlaceholder: string = 'BUSINESS.START_TIME';
    @Input() endTimePlaceholder: string = 'BUSINESS.END_TIME';

    businessHours = businessHours();
    dayToggleControls: FormControl[] = [];

    constructor(private fb: FormBuilder) { }

    ngOnInit() {
        this.initializeToggleControls();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['hoursFormArray'] && this.hoursFormArray) {
            this.initializeToggleControls();
        }
    }

    initializeToggleControls() {
        if (this.hoursFormArray && this.showDayToggles) {
            this.initializeDayToggleControls();
        }
    }

    initializeDayToggleControls() {
        this.dayToggleControls = this.hoursFormArray.controls.map((dayControl) => {
            const toggleControl = this.fb.control(this.isDayEnabled(dayControl));

            toggleControl.valueChanges.subscribe(enabled => {
                this.toggleDay(dayControl, enabled);
            });

            return toggleControl;
        });
    }

    getDayTranslationKey(day: string): string {
        return 'BUSINESS.DAYS.' + day?.toUpperCase();
    }

    isDayEnabled(dayControl: any): boolean {
        return dayControl.get('open')?.value !== 'Closed' && dayControl.get('close')?.value !== 'Closed';
    }

    toggleDay(dayControl: any, enabled: boolean): void {
        if (enabled) {
            dayControl.get('open')?.setValue('8:00 am');
            dayControl.get('close')?.setValue('5:00 pm');
        } else {
            dayControl.get('open')?.setValue('Closed');
            dayControl.get('close')?.setValue('Closed');
        }
    }

    getDayToggleControl(index: number): FormControl {
        return this.dayToggleControls[index];
    }
}
